import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { PIPELINE_STATS_ACTION_TYPE } from '../actions';

const initialState = {};

const pipelineStatsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case PIPELINE_STATS_ACTION_TYPE.FETCH_PIPELINE_STATS:
        draft[payload.pipelineId] = {
          isLoading: true,
          error: null,
          data: draft[payload.pipelineId]?.data || null,
        };
        break;

      case PIPELINE_STATS_ACTION_TYPE.FETCH_PIPELINE_STATS_SUCCESS:
        draft[payload.pipelineId] = {
          isLoading: false,
          error: null,
          data: payload.data,
        };
        break;

      case PIPELINE_STATS_ACTION_TYPE.FETCH_PIPELINE_STATS_FAILURE:
        draft[payload.pipelineId] = {
          ...draft[payload.pipelineId],
          isLoading: false,
          error: payload.error,
          isNotFound: !!payload.isNotFound,
        };
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default pipelineStatsReducer;
